import React from "react";
import { Link } from "react-router-dom";
import useMedia from "../componentsofcourse/useMedia";
import Assistance from "../Assets/img/Competitive/Assistance.png";
import Manish from "../Assets/img/Competitive/Image_30.png";
import Vivek from "../Assets/img/Competitive/Vivek.png";
import VivekJ from "../Assets/img/Competitive/vivekJ.png";
import Bajaj from "../Assets/img/Competitive/Bajaj.png";
import linkedin from "../Assets/img/Competitive/linkedin.png";
import amazon_app from "../Assets/img/Competitive/amazon_app.png";
import google_app from "../Assets/img/Competitive/google_app.png";
import Quadeye from "../Assets/img/Competitive/Quadeye.png";
import ms_app from "../Assets/img/Competitive/ms_app.png";
import oracle from "../Assets/img/Competitive/oracle.png";
import Amit from "../Assets/img/Competitive/Amit.png";
import Rakesh from "../Assets/img/Competitive/Rakesh.png";
import Vijay from "../Assets/img/Competitive/Vijay.png";
import Sanjay from "../Assets/img/Competitive/Sanjay.png";
import Avanish from "../Assets/img/Competitive/Avanish.png";
import Black from "../Assets/img/Competitive/black.png";
import CL_app from "../Assets/img/Home/cantileverlogo-cut.png";

import Mentors_mv from "../Assets/img/Competitive/mentors_mv.png";

const Mentor = () => {
	const matches = useMedia("(min-width : 768px )");
	const matchesCard = useMedia("(min-width : 1296px )");
	return (
		<div className="p-5" style={{ backgroundColor: "#F3C054" }}>
			<br />
			<br />
			<br />
			<h1
				style={{ fontFamily: "Poppins-Bold" }}
				className="text-white text-center"
			>
				Meet your Mentors
			</h1>
			<br />
			<br />
			<br />
			<br />

			<div className="container-fluid">
				{matches ? (
					<div className="row">
						<div className="col-md-12 col-xs-12 col-12"> </div>
						<div className="col-md-1 col-xs-1 col-1"> </div>
						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Manish}
									width="30%"
									className="mx-auto d-block"
								/>
								{matchesCard ? (
									<h5>Manish Kankani</h5>
								) : (
									<h5
										style={{
											fontSize: "1.9vw",
										}}
									>
										Manish Kankani
									</h5>
								)}
								<p>IIT, Roorkee</p>
								<b>Google Tech Lead</b>
								<br />
								<br />
								<img
									src={google_app}
									className="img-fluid mx-auto d-block"
								/>
								<br />

								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/manishkankani/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div
													className="mentors_bottom_text"
													style={{
														borderRadius: "25px",
													}}
												>
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<br />
						<div className="col"> </div>

						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Vivek}
									width="30%"
									className="mx-auto d-block"
								/>
								{matchesCard ? (
									<h5>Vivek Jhaver</h5>
								) : (
									<h5 style={{ padding: "3%" }}>
										Vivek Jhaver
									</h5>
								)}

								<p>VNIT</p>

								<b>SDE-2, Amazon</b>
								<br />
								<br />
								<img
									src={amazon_app}
									className="img-fluid mx-auto d-block"
								/>
								<br />

								<a
									style={{ textDecoration: "none" }}
									href=" https://www.linkedin.com/in/vivek-jhaver-8853a261/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<br />
						<div className="col"> </div>

						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Bajaj}
									width="30%"
									className="mx-auto d-block"
								/>
								{matchesCard ? (
									<div>
										<h5 style={{ fontSize: "18px" }}>
											Suresh Santhanam Mohan
										</h5>

										<p>IIIT Hyderabad</p>
										<b>Software Engineer at Microsoft</b>
									</div>
								) : (
									<div>
										<h5 style={{ fontSize: "1.1vw" }}>
											Suresh Santhanam Mohan
										</h5>

										<p>IIIT Hyderabad</p>
										<b style={{ fontSize: "0.9vw" }}>
											Software Engineer at Microsoft
										</b>
									</div>
								)}

								<br />
								<br />

								<img
									src={ms_app}
									className="img-fluid mx-auto d-block mb-2"
								/>
								<br />

								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/sureshsan/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
							<br />
						</div>
						<br />
						<br />

						<div className="col-md-1 col-xs-1 col-1"> </div>
						<div className="col-md-12 col-xs-12 col-12"> </div>
						<div className="col-md-1 col-xs-1 col-1"> </div>
						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={VivekJ}
									width="30%"
									className="mx-auto d-block"
								/>
								{matchesCard ? (
									<h5>Vivek Jhunjhunwala</h5>
								) : (
									<h5
										style={{
											fontSize: "1.4vw",
											padding: "1%",
										}}
									>
										Vivek Jhunjhunwala
									</h5>
								)}

								<p>IIT Bombay</p>

								<b>Partner at Quadeye</b>
								<br />
								<br />

								<img
									src={Quadeye}
									className="img-fluid mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/vivek-jhunjhunwala/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<div className="col"></div>
						<br />
						<br />
						<br />
						<div className="col-md-3 col-xs-3 col-3 mb-4">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Sanjay}
									width="30%"
									className="mx-auto d-block"
								/>
								<h5>Sanjay Nair</h5>
								{matchesCard ? (
									<p>Manipal Institute of Technology</p>
								) : (
									<p style={{ fontSize: "1.1vw" }}>
										Manipal Institute of Technology
									</p>
								)}

								{/* <p>Manipal Institute of Technology</p> */}

								<b>SDE-2, Amazon</b>
								<br />
								<br />

								<img
									src={amazon_app}
									className="img-fluid mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/sanjay-nair-/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<div className="col"> </div>

						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Amit}
									width="30%"
									className="mx-auto d-block"
								/>
								<h5>Amit Vaid</h5>
								<p>VNIT</p>
								{matchesCard ? (
									<b>Senior Principal Data Scientist</b>
								) : (
									<b style={{ fontSize: "1.1vw" }}>
										Senior Principal Data Scientist
									</b>
								)}
								<br />
								<br />
								<img
									src={oracle}
									className="img-fluid mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/amitvaid/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<div className="col-md-1 col-xs-1 col-1"> </div>
						<div className="col-md-12 col-xs-12 col-12"> </div>
						<div className="col-md-1 col-xs-1 col-1"> </div>
						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Avanish}
									width="30%"
									className="mx-auto d-block"
								/>
								<h5>Avanish Mundhra</h5>
								<p>VNIT</p>
								{matchesCard ? (
									<b>Founder & CEO - Cantilever Labs</b>
								) : (
									<b style={{ fontSize: "1vw" }}>
										Founder & CEO - Cantilever Labs
									</b>
								)}

								<br />
								<br />
								<img
									width="15%"
									src={CL_app}
									className=" mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/avanish-mundhra-6a938848/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>

						<div className="col"></div>

						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Rakesh}
									width="30%"
									className="mx-auto d-block"
								/>
								<h5>Rakesh Patel</h5>
								<p>IIT Bombay</p>
								<b>CoFounder, Cantilever Labs</b>
								<br />
								<br />
								<img
									width="15%"
									src={CL_app}
									className="mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/rakeshpatel21/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>

						<div className="col"> </div>
						<div className="col-md-3 col-xs-3 col-3">
							<div
								style={{
									backgroundColor: "#f6f6f6",
									borderTopLeftRadius: "25px",
									borderTopRightRadius: "25px",
									borderEndEndRadius: "25px",
									borderEndStartRadius: "25px",
								}}
								className="text-center"
							>
								<br />
								<img
									src={Vijay}
									width="30%"
									className="mx-auto d-block"
								/>
								<h5>Vijay Kaushik</h5>
								<p>IIT Bombay</p>
								<b>CoFounder, Cantilever Labs</b>
								<br />
								<br />
								<img
									width="15%"
									src={CL_app}
									className="mx-auto d-block"
								/>
								<br />
								<a
									style={{ textDecoration: "none" }}
									href="https://www.linkedin.com/in/vijaykaushikcl/"
									target="_blank"
								>
									<table
										className="mentors_bottom"
										width="100%"
									>
										<tr>
											<td>
												<div className="mentors_bottom_text">
													Linked{" "}
													<span
														style={{
															padding: "2px",
														}}
														className="fa fa-linkedin "
													></span>
												</div>
											</td>
											<td></td>
										</tr>
									</table>
								</a>
							</div>
						</div>
						<div className="col-md-1 col-xs-1 col-1"> </div>

						<div className="col-md-1 col-xs-1 col-1"> </div>
					</div>
				) : (
					<div>
						<img src={Mentors_mv} width="100%" />
					</div>
				)}
			</div>
			<br />
			<br />
			<br />
			<br />
		</div>
	);
};

export default Mentor;
